import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getUserType } from '../utils/authUtils';

const OperationPage: React.FC = () => {
    const { t } = useTranslation();
    const userType = getUserType();
  return (
    <div className="p-6">
      <h1 className="text-2xl font-medium mb-4">{t('Operations')}</h1>
      <p>{t('Select a section to proceed:')}</p>
      <ul className="mt-4 space-y-2">
        <li>
          <Link to="/tasks" className="text-info-500 hover:underline">
            {t('Tasks')}
          </Link>
        </li>
        <li>
          <Link to="/analytics" className="text-info-500 hover:underline">
            {t('Analytics')}
          </Link>
        </li>
        {userType.includes('LawFirmAdmin') && 
        <>
        <li>
          <Link to="/management" className="text-info-500 hover:underline">
            {t('Management')}
          </Link>
        </li>
        <li>
          <Link to="/finance" className="text-info-500 hover:underline">
            {t('Finance')}
          </Link>
        </li>
        </>
        }
      </ul>
    </div>
  );
};

export default OperationPage;
